module.exports = __webpack_public_path__ + "static/media/carroussel_15.1c0263f8.jpg";